// extracted by mini-css-extract-plugin
export default {"breadCrumb":"styles_breadCrumb__WVPwM","breadCrumb_button":"styles_breadCrumb_button__tD-5N"};